import { createContext, useContext, useMemo } from 'react'

import { useQuery } from '@redwoodjs/web'

import { GET_CUSTOM_STEPS } from 'src/graphql/customSteps.graphql'

const CustomStepsContext = createContext(null)

const CustomStepsContextProvider = ({ children }) => {
  const { data, loading, refetch } = useQuery(GET_CUSTOM_STEPS, {
    variables: { pageInfo: { offset: 0, limit: 200 } },
    fetchPolicy: 'cache-and-network',
  })

  const value = useMemo(() => {
    const customSteps = data?.customSteps?.items ?? []
    return {
      customSteps,
      loading,
      refetch,
      options: customSteps.map((step) => ({
        label: step.label,
        value: step.customStepId,
      })),
      labelById: Object.fromEntries(
        customSteps.map((step) => [step.customStepId, step.label])
      ),
    }
  }, [data, loading, refetch])

  return (
    <CustomStepsContext.Provider value={value}>
      {children}
    </CustomStepsContext.Provider>
  )
}

const useCustomSteps = () => useContext(CustomStepsContext)

export { CustomStepsContext, CustomStepsContextProvider, useCustomSteps }
